var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"form-control inputtags",attrs:{"type":"text","name":"tag_name","id":_vm.id,"data-role":"tagsinput"}})}
var staticRenderFns = []

export { render, staticRenderFns }